var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_987_7918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2696 23.7247H6.53213C6.31498 23.7247 6.10673 23.6384 5.95319 23.4849C5.79964 23.3313 5.71338 23.1231 5.71338 22.9059V4.8934C5.71338 4.67625 5.79964 4.468 5.95319 4.31445C6.10673 4.16091 6.31498 4.07465 6.53213 4.07465H16.3571L22.0884 9.8059V22.9059C22.0884 23.1231 22.0021 23.3313 21.8486 23.4849C21.695 23.6384 21.4868 23.7247 21.2696 23.7247Z",
    stroke: "#374151",
    strokeWidth: 1.6375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3572 4.07465V9.8059H22.0884",
    stroke: "#374151",
    strokeWidth: 1.6375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0354 16.7653L13.901 19.6309L16.7667 16.7653",
    stroke: "#374151",
    strokeWidth: 1.6375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9009 13.0809V19.6309",
    stroke: "#374151",
    strokeWidth: 1.6375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_987_7918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.2,
    height: 26.2,
    fill: "white",
    transform: "translate(0.800049 0.799988)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadExcel);
export default __webpack_public_path__ + "static/media/downloadExcel.1e2bed0a8286b881843410ebf270ca66.svg";
export { ForwardRef as ReactComponent };